import React, { useState } from "react";
import "../App.css";

const Mainbox = () => {
  const [text, setText] = useState("");
  const [uppertext, setUpperText] = useState("");
  const [words, setword] = useState(0);
  const [char, setChar] = useState(0);
  const [isLoading, setIsLoading] = useState(false); // Add a loading state
  const [loadingBackgroundColor, setLoadingBackgroundColor] =
    useState("#ffc107"); // Default color

  const click = (event) => {
    console.log(text);
    setText(event.target.value);
  };

  const uppercased = () => {
    setUpperText("");
    setIsLoading(true); // Show loading spinner
    setLoadingBackgroundColor("#0d6efd"); // Set background color for uppercase

    let newtext = text.toUpperCase();
    // Hide loading spinner after 5 seconds
    setTimeout(() => {
      setIsLoading(false);
      setLoadingBackgroundColor("#ffc107"); // Reset background color
      setUpperText(newtext);
    }, 3000);
  };
  const lowercased = () => {
    setUpperText("");
    setIsLoading(true); // Show loading spinner
    setLoadingBackgroundColor("#ffc107"); // Set background color for lowercase

    let newtext = text.toLowerCase();

    // Hide loading spinner after 5 seconds
    setTimeout(() => {
      setIsLoading(false);
      setLoadingBackgroundColor("#ffc107"); // Reset background color
      setUpperText(newtext);
    }, 3000);
  };
  const characterCount = () => {
    let chars = text.length;
    setChar(chars);
  };
  const copyToClipboard = (textToCopy) => {
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    alert("Text Coped!");
  };
  const wordCount = () => {
    let word = text.split(/\s+/).filter((e) => {
      return e.length !== 0;
    }).length;
    setword(word);
  };

  const ExtraSpaces = () => {
    let newText = text.split(/[ ]+/);
    uppercased(newText.join(" "));
    // props.showAlert("Extra spaces removed!", "success");
  };

  return (
    <>
      <div className="container my-3  pt-4 col-9 ">
        <h2 className="text-center my-2 mb-4">
          Paste Text here to see{" "}
          <strong style={{ color: "#F74242", textDecoration: "underline" }}>
            {" "}
            Magic
          </strong>
          🪄
        </h2>
        <textarea
          className="form-control form-control-lg"
          id="exampleFormControlTextarea1"
          placeholder="Add Text Here"
          onChange={click}
          value={text}
          rows="8"></textarea>
        <div className="container my-3 ">
          <button
            disabled={text.length === 0}
            className="btn btn-outline-primary my-3 ms-2 float-end"
            onClick={uppercased}>
            Convert to Upper Case
          </button>
          <button
            disabled={text.length === 0}
            className="btn btn-outline-warning my-3 ms-2 float-end"
            onClick={lowercased}>
            Convert to Lower Case
          </button>
          <button
            className="btn btn-outline-info my-3 ms-2 float-end"
            disabled={text.length === 0}
            onClick={characterCount}>
            Character Count
          </button>

          <button
            className="btn btn-outline-light my-3 ms-2 float-end"
            disabled={text.length === 0}
            onClick={wordCount}>
            Word Count
          </button>
          <button
            className="btn btn-outline-secondary my-3 ms-2 float-end"
            disabled={text.length === 0}
            onClick={ExtraSpaces}>
            Remove Extra Space
          </button>
          <button
            className="btn btn-outline-danger my-3 ms-2 float-end"
            onClick={() => {
              setText("");
              setUpperText("");
              setChar();
              setword();
            }}>
            Clear Text
          </button>
        </div>
      </div>

      <div className="textsummary  container my-5 pt-4 col-9">
        <h2 className="mb-3">Your Text Summary.</h2>
        <p>
          Total Words are :{" "}
          <strong style={{ color: "#7563ED  " }}>{words}</strong>
        </p>
        <p>
          Total Characters are :{" "}
          <strong style={{ color: "#7563ED" }}> {char}</strong>
        </p>
        <h3 className="my-3">
          {" "}
          <strong style={{ color: "white" }}>Generated Text : </strong>
        </h3>
        <div className="container gentext p-3 pt-4 bg-info bg-opacity-10 border border-info border rounded">
          {isLoading && (
            <div
              className="spinner-grow load"
              role="status"
              style={{ backgroundColor: loadingBackgroundColor }}>
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
          <p id="text">{uppertext}</p>
        </div>
        <div className="container float-end">
          <button
            disabled={text.length === 0}
            className="btn btn-outline-info copy my-3 ms-2 float-end"
            onClick={() => copyToClipboard(uppertext)}>
            <i class="fa fa-copy "></i>
            Copy Text
          </button>
        </div>
      </div>
    </>
  );
};

export default Mainbox;
